export default "__VITE_ASSET__613fdc30__"